import { createActions, createReducer } from 'reduxsauce'
import Immutable from 'seamless-immutable'

export const INITIAL_STATE = Immutable({
  success: false,
  loading: false,
  loaded: false,
  data: {},
  error: {},
})

const { Types, Creators } = createActions({
  fetchPartnersRequest: null,
  fetchPartnersConnected: ['data'],
  fetchPartnersError: ['error'],
  fetchPartnersDisconnected: null,

  fetchPartnerRequest: ['id'],
  fetchPartnerSuccess: ['partner'],
  fetchPartnerError: ['error'],

  savePartnerRequest: ['params', 'callback'],
  savePartnerSuccess: null,
})

export const savePartnerRequest = state => state.set('loading', true)

export const savePartnerSuccess = state => state.set('loading', false)

export const partnersRequest = state => state.set('loading', true)
export const partnersDisconnected = state => state.set('loading', false)
export const partnersConnected = (state, { data }) =>
  state
    .set('data', data)
    .set('loading', false)
    .set('loaded', true)
export const partnersError = (state, { error }) => state.set('error', error).set('loading', false)

export const fetchPartnerRequest = state => state.set('loading', true)
export const fetchPartnerSuccess = (state, { partner }) =>
  state
    .setIn(['data', partner.key], partner)
    .set('success', true)
    .set('loading', false)
export const fetchPartnerError = (state, { error }) =>
  state
    .set('error', error)
    .set('success', false)
    .set('loading', false)

export const partnerReducer = createReducer(INITIAL_STATE, {
  [Types.FETCH_PARTNERS_REQUEST]: partnersRequest,
  [Types.FETCH_PARTNERS_CONNECTED]: partnersConnected,
  [Types.FETCH_PARTNERS_DISCONNECTED]: partnersDisconnected,
  [Types.FETCH_PARTNERS_ERROR]: partnersError,

  [Types.FETCH_PARTNER_REQUEST]: fetchPartnerRequest,
  [Types.FETCH_PARTNER_SUCCESS]: fetchPartnerSuccess,
  [Types.FETCH_PARTNER_ERROR]: fetchPartnerError,

  [Types.SAVE_PARTNER_REQUEST]: savePartnerRequest,
  [Types.SAVE_PARTNER_SUCCESS]: savePartnerSuccess,
})

export const PartnerTypes = Types
export default Creators



// WEBPACK FOOTER //
// ./src/reducers/partnerReducer.js